import React from "react";
import { Stack, Typography } from "@mui/material";
//Src
import "../../App.css";
import SchoolLogo from "../../Assets/logoReport.png";
import SymbolLogo from "../../Assets/symbol.jpg";
import { getKhmerNumber } from "../../Function/DynamicFn";

export default function PrintStudentBook({ editData }) {
  // console.log("editData", editData);
  const sumOfQTY = editData?.provideBooks?.reduce(
    (total, data) => total + (data.qty || 0),
    0
  );

  return (
    <Stack direction="column">
      <Stack direction="row" width="100%">
        <Stack justifyContent="center" width="20%">
          <img
            src={SchoolLogo}
            alt="Img"
            style={{ width: "95px", marginTop: "15px" }}
          />
        </Stack>
        <Stack direction="column" width="75%">
          <Stack width="80%" justifyContent="center" alignItems="center">
            <Typography className="cam-titel-kh">
              ព្រះរាជាណាចក្រកម្ពុជា
            </Typography>
            <Typography className="cam-titel-en">
              Kingdom Of Cambodia
            </Typography>
            <Typography className="cam-titel-kh">
              ជាតិ សាសនា ព្រះមហាក្សត្រ
            </Typography>
            <Typography className="cam-titel-en">Nation Region King</Typography>
            <img src={SymbolLogo} alt="" width="130px" />
          </Stack>
        </Stack>
      </Stack>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginTop="8px"
      >
        <Typography className="academicyear-title-kh">
          សៀវភៅផ្ដល់ឱ្យសិស្សសម្រាប់ឆ្នាំសិក្សា
          {getKhmerNumber(editData?.academicYearId?.academicYearTitle)}
        </Typography>
        <Typography className="academicyear-title-en">
          Students's Books For {editData?.academicYearId?.academicYearTitle}{" "}
          Academic Year
        </Typography>
      </Stack>
      <Stack direction="column" spacing={2} sx={{ marginTop: "2px" }}>
        <table className="table-view-print">
          <thead className="table-student-book-head">
            <tr className="table-student-book-head-first">
              <th
                colSpan={3}
                className="first-table-head-text"
                style={{ textAlign: "left" }}
              >
                <Stack direction="row" justifyContent="space-between">
                  <Stack direction="row" spacing={0.5}>
                    <span>ឈ្មោះសិស្ស</span>
                    <span>៖</span>
                    <span>{editData?.studentId?.englishName}</span>
                  </Stack>
                  <Stack direction="row" spacing={1}>
                    <span>Nº</span>
                  </Stack>
                </Stack>
              </th>
              {/* <th
                className="first-table-head-text"
                style={{ textAlign: "right" }}
              >
                Nº
              </th> */}
              <th></th>
            </tr>
            <tr className="table-student-book-head-second">
              <th
                style={{
                  textAlign: "center",
                  width: "5%",
                  padding: "4px 4px 0px 4px",
                }}
              >
                <div className="table-book-header-title-kh">ល.រ</div>
                <div className="table-book-header-title-en">N.º</div>
              </th>
              <th
                style={{
                  textAlign: "center",
                  width: "20%",
                  padding: "4px 4px 0px 4px",
                }}
              >
                <div className="table-book-header-title-kh">លេខកូដ</div>
                <div className="table-book-header-title-en">ISBN</div>
              </th>
              <th style={{ textAlign: "center", padding: "4px 4px 0px 4px" }}>
                <div className="table-book-header-title-kh">ការបរិយាយ</div>
                <div className="table-book-header-title-en">Description</div>
              </th>
              <th
                style={{
                  textAlign: "center",
                  width: "5%",
                  padding: "4px 4px 0px 4px",
                }}
              >
                <div className="table-book-header-title-kh">ចំនួន</div>
                <div className="table-book-header-title-en">Unit</div>
              </th>
            </tr>
            <tr className="table-student-book-head-second">
              <th
                style={{ textAlign: "center", padding: "4px 4px 0px 4px" }}
                colspan={4}
              >
                <div
                  className="table-book-header-title-en"
                  style={{ color: "blue", fontWeight: "bold" }}
                >
                  {editData?.enrollmentId?.classId?.gradeId?.gradeName}
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="table-student-book-body">
            {editData?.provideBooks?.map((row, index) => (
              <tr className="table-book-body">
                <td
                  className="table-book-body-field"
                  style={{ textAlign: "center" }}
                >
                  {index + 1}
                </td>
                <td
                  className="table-book-body-field"
                  style={{ textAlign: "center" }}
                >
                  {row?.listMaterialUnitId?.barcode}
                </td>
                <td className="table-book-body-field">
                  {row?.listMaterialUnitId?.materialId?.materialEnName}
                </td>
                <td
                  className="table-book-body-field"
                  style={{ textAlign: "center" }}
                >
                  {row?.qty}
                </td>
              </tr>
            ))}

            <tr style={{ backgroundColor: "#e1f5fe" }}>
              <td
                colspan="3"
                className="table-book-body-field"
                style={{
                  textAlign: "center",
                  color: "blue",
                  fontWeight: "bold",
                }}
              >
                Total
              </td>
              <td
                className="table-book-body-field"
                style={{ textAlign: "center", color: "red" }}
              >
                {sumOfQTY}
              </td>
            </tr>
          </tbody>
        </table>
      </Stack>
      <Stack direction="row" width="100%" marginY="20px">
        <Stack
          direction="column"
          spacing={5}
          justifyContent="center"
          width="50%"
          alignItems="center"
        >
          <Stack
            direction="column"
            spacing={0.5}
            justifyContent="center"
            alignItems="center"
          >
            <Typography className="student-book-date-kh">
              សៀមរាប ថ្ងៃទី.......... ខែ..............ឆ្នាំ២០២.....
            </Typography>
            <Typography className="student-book-date-kh">
              Siem Reap, Date................................
            </Typography>
            <Typography className="student-book-reciever">
              អ្នកទទួល/Reciever
            </Typography>
          </Stack>
          <Stack
            direction="column"
            spacing={0.5}
            justifyContent="center"
            alignItems="center"
          >
            <Typography className="student-book-date-kh">
              ...................................
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction="column"
          spacing={5}
          justifyContent="center"
          width="50%"
          alignItems="center"
        >
          <Stack
            direction="column"
            spacing={0.5}
            justifyContent="center"
            alignItems="center"
          >
            <Typography className="student-book-date-kh">
              សៀមរាប ថ្ងៃទី.......... ខែ..............ឆ្នាំ២០២.....
            </Typography>
            <Typography className="student-book-date-kh">
              Siem Reap, Date................................
            </Typography>
            <Typography className="student-book-reciever">
              អ្នកផ្ដល់ជូន/Provider
            </Typography>
          </Stack>
          <Stack
            direction="column"
            spacing={0.5}
            justifyContent="center"
            alignItems="center"
          >
            <Typography className="student-book-date-kh">
              ...................................
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
